
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.5002 19.1666C15.5628 19.1666 19.6668 15.0625 19.6668 9.99992C19.6668 4.93731 15.5628 0.833252 10.5002 0.833252C5.43755 0.833252 1.3335 4.93731 1.3335 9.99992C1.3335 15.0625 5.43755 19.1666 10.5002 19.1666ZM15.9148 7.65778C16.2321 7.3244 16.2191 6.79693 15.8857 6.47963C15.5524 6.16232 15.0249 6.17535 14.7076 6.50873L9.14688 12.4406L6.2922 9.41777C5.97461 9.08467 5.44712 9.0721 5.11402 9.38968C4.78092 9.70727 4.76835 10.2348 5.08594 10.5679L8.54427 14.2239C8.70163 14.3889 8.91973 14.4823 9.14776 14.4822C9.37579 14.4821 9.59382 14.3885 9.75103 14.2233L15.9148 7.65778Z","fill":"#5D5CFD"}})])
          )
        }
      }
    